import { styled } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro'

export const StyledAbsenceDetailGrid = styled(DataGridPro)(() => ({
  // Custom scrollbar styling
  '& ::-webkit-scrollbar': {
    width: '6px',
  },

  // Root DataGrid styling
  '&.MuiDataGrid-root': {
    border: 'none !important',
    borderRadius: '16px',
    overflow: 'hidden',
    overflowX: 'hidden',
    width: '100%',
    boxSizing: 'border-box',
  },

  // Main container styling
  '& .MuiDataGrid-main': {
    border: '0.38px solid #EEEEEE',
    borderRadius: '16px',
    marginTop: '24px',
    overflowX: 'hidden',
    width: '100%',
  },

  // Virtual scroller styling
  '& .MuiDataGrid-virtualScroller': {
    overflowX: 'hidden !important',
    width: '100%',
  },

  // Virtual scroller content styling
  '& .MuiDataGrid-virtualScrollerContent': {
    minHeight: '200px!important',
    width: '100%',
    boxSizing: 'border-box',
  },

  // Container top/bottom styling
  '& .MuiDataGrid-container--top, & .MuiDataGrid-container--bottom': {
    overflowX: 'hidden',
  },

  // Header styling
  '.header, .MuiDataGrid-columnHeaders': {
    backgroundColor: 'rgb(247, 247, 247)',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
  },

  // Zebra striping for rows
  '& .MuiDataGrid-main .MuiDataGrid-virtualScroller .MuiDataGrid-row:nth-of-type(even)': {
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.02)), #FFFFFF',
  },
  '& .MuiDataGrid-main .MuiDataGrid-virtualScroller .MuiDataGrid-row:nth-of-type(odd)': {
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), #FFFFFF',
  },
  // Row hover — Mui-hovered is set on all row elements (incl. pinned) by DataGrid Pro
  '& .MuiDataGrid-main .MuiDataGrid-virtualScroller .MuiDataGrid-row.Mui-hovered:nth-of-type(even)': {
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.06)), #FFFFFF',
  },
  '& .MuiDataGrid-main .MuiDataGrid-virtualScroller .MuiDataGrid-row.Mui-hovered:nth-of-type(odd)': {
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)), #FFFFFF',
  },

  // Detail panel styling and animations
  '.MuiDataGrid-detailPanel': {
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    transition: 'all 0.3s ease-in-out',
    overflow: 'hidden',
    width: '100%',
    boxSizing: 'border-box',
    '& > *': {
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    '& .MuiNativeSelect-select option': {
      font: '13px "Poppins", sans-serif',
    },
  },

  '& .MuiDataGrid-detailPanels': {
    transition: 'height 0.3s ease-in-out',
  },

  '& .MuiDataGrid-detailPanel': {
    transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
    maxHeight: '1000px',
    opacity: 1,
  },

  '& .MuiDataGrid-detailPanel[aria-expanded="false"]': {
    maxHeight: '0px',
    opacity: 0,
    overflow: 'hidden',
  },

  '& .MuiDataGrid-detailPanel[aria-expanded="true"]': {
    maxHeight: '1000px',
    opacity: 1,
  },

  // Column header styling
  '& .MuiDataGrid-columnHeader': {
    padding: '0 16px',
    whiteSpace: 'normal !important',
    wordWrap: 'break-word',
    height: 'auto',
  },

  '& .MuiDataGrid-columnHeaderTitle': {
    whiteSpace: 'normal !important',
    wordWrap: 'break-word',
    textOverflow: 'unset',
    overflow: 'visible',
  },

  '& .MuiDataGrid-columnHeaderTitleContainer': {
    whiteSpace: 'normal !important',
    wordWrap: 'break-word',
    height: 'auto',
    alignItems: 'flex-start',
    paddingTop: '8px',
  },

  // Cell styling
  '& .MuiDataGrid-cell': {
    padding: '0 16px',
    borderTop: 'none !important',
    borderBottom: 'none !important',
  },

  // Focus outline removal for accessibility compliance
  '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
    outline: 'transparent',
  },

  '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },

  // Detail panel toggle button styling
  '& .MuiDataGrid-cell[data-field="__detail_panel_toggle__"]': {
    padding: '0 8px',
    justifyContent: 'center',
  },

  '& .MuiDataGrid-columnHeader[data-field="__detail_panel_toggle__"]': {
    padding: '0 8px',
    justifyContent: 'center',
  },

  '& .MuiDataGrid-cell[data-field="__detail_panel_toggle__"] button': {
    outline: 'none !important',
    '&:focus': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
    '&:focus-visible': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
  },

  // Pinned columns styling
  '& .MuiDataGrid-pinnedColumns': {
    boxShadow: 'none !important',
    borderLeft: 'none !important',
  },

  '& .MuiDataGrid-pinnedColumnsContainer': {
    boxShadow: 'none !important',
    borderLeft: 'none !important',
  },

  '& .MuiDataGrid-pinnedColumns--right': {
    borderLeft: 'none !important',
    boxShadow: 'none !important',
  },

  '& .MuiDataGrid-pinnedColumnHeaders--right': {
    borderLeft: 'none !important',
    boxShadow: 'none !important',
  },

  '& .MuiDataGrid-pinnedColumns .MuiDataGrid-columnHeaders': {
    backgroundColor: 'rgb(247, 247, 247)',
  },

  '& .MuiDataGrid-pinnedColumns .MuiDataGrid-columnHeader': {
    backgroundColor: 'rgb(247, 247, 247)',
  },

  // Action column styling (edit/delete buttons)
  '& .MuiDataGrid-cell[data-field="edit"], & .MuiDataGrid-cell[data-field="delete"]': {
    padding: '0 4px',
    justifyContent: 'center',
  },

  '& .MuiDataGrid-columnHeader[data-field="edit"], & .MuiDataGrid-columnHeader[data-field="delete"]':
    {
      padding: '0 4px',
      justifyContent: 'center',
      backgroundColor: 'rgb(247, 247, 247)',
      whiteSpace: 'normal !important',
      minHeight: '56px',
      height: 'auto',
    },
}))
